// inv/src/components/lists/InvestorsStats.jsx
import { useTranslation } from 'react-i18next';
import CTAHover from '../ui/CTAHover';
import { Badge } from '../ui/badge';
import CountryFlag from '../countryFlags/countryFlag';

const InvestorsStats = ({ total, industry, country }) => {
  const { t } = useTranslation();

  return (
    <section className="bg-white px-4 py-6">
      <div className="w-full mx-auto max-w-screen-xl">
        <div className="grid grid-cols-1 gap-6 sm:gap-8 md:gap-12 lg:gap-16 mt-4">
          <div className="stats shadow p-4 rounded-lg bg-white">
            <div className="stat">
              {/* Heading */}
              <div className="text-sm stat-title text-gray-700">
                {t('pageHome.content.t10')}
              </div>

              <div className="stat-value mt-3 text-3xl sm:text-4xl text-stone-900">
                {total}
              </div>

              <div className="flex flex-wrap items-center gap-2 mt-2">
                {industry && (
                  <Badge
                    text={industry}
                    variant="v1"
                  />
                )}
                {country && (
                  <CountryFlag
                    countryName={country}
                    alt="Country flag"
                    className="w-6 h-4"
                  />
                )}
              </div>

              <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 mt-4">
                <p
                  className="text-sm text-gray-600"
                  dangerouslySetInnerHTML={{
                    __html: t('pageLists.t1')
                  }}
                />
                <CTAHover
                  text={t('menu.signUp')}
                  href="signup"
                  align="left"
                  bgColor="bg-yellow-400"
                  textColor="text-stone-800"
                  hoverTextColor="text-white"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default InvestorsStats;
